/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.GroupContactResponse,
  (requestParams: vp.GroupContactRequest) => void,
  (requestParams: vp.GroupContactRequest) => Promise<vp.GroupContactResponse>,
  () => void,
];

function useFetchGroupContact({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.GroupContactRequest>();
  const [response, setResponse] = useState<vp.GroupContactResponse>({
    ErrorMessage: '',
    Success: false,
    Contacts: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.GroupContactRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchGroupContact(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.GroupContactRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.GroupContactRequest) => api.fetchGroupContact(requestParams, source),
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        Contacts: {},
      });
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchGroupContact);
